"use strict";

(self.webpackChunkuklash = self.webpackChunkuklash || []).push([ [ 911 ], {
  911: function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
    __webpack_require__.r(__webpack_exports__), __webpack_exports__.default = void (customElements.get("announcement-bar") || customElements.define("announcement-bar", class extends HTMLElement {
      slides=this.querySelectorAll("li");
      index=0;
      delay=parseInt(this.dataset.autoplay || 3e3);
      constructor() {
        super();
      }
      update() {
        this.slides.forEach(((slide, index) => {
          index === this.index ? (slide.classList.add("opacity-100"), slide.classList.remove("opacity-0"), 
          slide.classList.remove("pointer-events-none")) : (slide.classList.add("opacity-0"), 
          slide.classList.remove("opacity-100"), slide.classList.add("pointer-events-none"));
        }));
      }
      init() {
        setInterval((() => {
          this.index = this.index + 1, this.index >= this.slides.length && (this.index = 0), 
          this.update();
        }), this.delay);
      }
      connectedCallback() {
        this.slides.length > 1 && this.init();
      }
    }));
  }
} ]);